import {SystemUser} from '../../models/system-user.model';
import {ValidationError} from '../../models/validation-error.model';
import {SearchQueryParams} from '../../models/search-query-params.model';

export namespace UserActions {
    export class GetById {
        static readonly type = 'UserActions.GetById';

        constructor(public userId: number) {
        }
    }

    export class GetListPage {
        static readonly type = '[User] GetListPage';

        constructor(public partnerId: number, public localizationId: number, public params?: SearchQueryParams) {
        }
    }

    export class Activate {
        static readonly type = '[User] Activate';

        constructor(public partnerId: number, public userId: number) {
        }
    }

    export class Deactivate {
        static readonly type = '[User] Deactivate';

        constructor(public partnerId: number, public userId: number) {
        }
    }

    export class PassReset {
        static readonly type = '[User] Pass Reset';

        constructor(public partnerId: number, public userId: number) {
        }
    }

    export class Add {
        static readonly type = '[User] Add';

        constructor(public partnerId: number, public readonly user: SystemUser) {
        }
    }

    export class Update {
        static readonly type = '[User] Update';

        constructor(public readonly user: SystemUser) {
        }
    }

    export class FormFailure {
        static readonly type = '[User] FormFailure';

        constructor(public readonly validationErrors: ValidationError[]) {
        }
    }

    export class Clear {
        static readonly type = 'UserActions.Clear';
    }

    export class ListClear {
        static readonly type = 'UserActions.ListClear';
    }

    export class GetRoleFieldList {
        static readonly type = 'UserActions.GetRoleFieldList';

        constructor(public readonly partnerId: number) {
        }
    }

    export class SellerList {
        static readonly type = 'UserActions.SellerList';
    }
}
